<template>
  <div id="container"></div>
</template>

<script>
export default {
  mounted() {
    console.log(this.$route.query);

    var map = new BMap.Map("container");
    var point = new BMap.Point(this.$route.query.cnLongitude,this.$route.query.cnLatitude);
    map.centerAndZoom(point, 14);
    var mk = new BMap.Marker(point);
    map.addOverlay(mk);
    //腾讯地图
    // let center = this.$route.query;
    // var center = new qq.maps.LatLng(this.$route.query.tcLatitude, this.$route.query.tcLongitude);

    // var map = new qq.maps.Map(document.getElementById("container"), {
    //   center: center, // 地图的中心地理坐标。
    //   zoom: 14 // 地图的中心地理坐标。
    // });

    // var marker = new qq.maps.Marker({
    //   //设置Marker的位置坐标
    //   position: center,
    //   //设置显示Marker的地图
    //   map: map
    // });
  }
};
</script>

<style>
#container {
  min-width: 100vw;
  min-height: 100vh;
}
</style>